<template>
  <div :class="['txt-color', 'flex', { h150: expandImage }]">
    <div
      @click="moveLeft(scope.$index)"
      class="flex items-center btn-move"
      v-if="expandImage"
    >
      <i
        v-show="
          getImgUrl(scope.row.bizData.surveySubjects[index]['column_' + index])
            ?.length > 0 && rowPageStates[scope.$index]?.currentPage > 1
        "
        class="el-icon-arrow-left btn-left"
      ></i>
    </div>
    <span
      v-for="(img, idx) in getImgUrl(
        scope.row.bizData.surveySubjects[index]['column_' + index],
        rowPageStates[scope.$index]?.currentPage || 1,
        rowPageStatespageSize
      )"
    >
      <el-tooltip
        v-if="!expandImage"
        :width="420"
        popper-class="tooltip-item"
        effect="light"
        placement="right"
      >
        <div slot="content">
          <el-image
            style="height: 400px; margin-right: 8px"
            :src="img.subjectAnswer"
            fit="contain"
          >
          </el-image>
        </div>
        <span
          @click="
            previewImg(
              scope.row.bizData.surveySubjects[index]['column_' + index],
              idx
            )
          "
          class="img-box"
          >图片{{ idx + 1 }}</span
        >
      </el-tooltip>
      <span v-if="!expandImage">
        {{ getComma(scope.row, index, idx) }}
      </span>
      <div
        v-if="expandImage"
        class="mt18"
        style="width: 120px; margin-right: 8px"
      >
        <el-image
          style="height: 120px; width: 120px; margin-top: 20px"
          :src="img.subjectAnswer"
          :preview-src-list="[img.subjectAnswer]"
        >
        </el-image>
        <div
          class="img-text font-S12 t-center"
          v-if="onShowBtn(img)"
          :style="getBgStyle(img, index)"
          @click="onAuditImgDialog(scope.row, img)"
        >
          <div class="flex items-center">
            <div
              :style="isReportMap[isReportEnum.N].bageStyle"
              v-if="img.suspectInfo.reportType != ReportTypeEnum.AI"
              class="text-bage mr5"
            >
              {{ img.suspectInfo.afterSuspectType.length }}
            </div>
            <div class="nowrap-ellipsis w74">
              <!-- 待审核图片系统识别文案 -->
              <span
                v-if="
                  [1].includes(activeTab) &&
                  img.suspectInfo.reportType != ReportTypeEnum.AI
                "
              >
                {{
                  $getNameByKey(
                    img.suspectInfo.afterSuspectType?.[0],
                    "图像识别不合规场景-待审核"
                  )
                }}
              </span>
              <!--部分合格 不合格 文案  -->
              <span
                v-if="
                  [3, 4].includes(activeTab) &&
                  img.suspectInfo.reportType != ReportTypeEnum.AI
                "
              >
                {{
                  $getNameByKey(
                    img.suspectInfo.afterSuspectType?.[0],
                    "图像识别不合规场景-已审核"
                  )
                }}
              </span>
            </div>
          </div>
          <el-button
            v-if="!img.notSuspectInfo"
            size="mini"
            type="text"
            @click="onAuditImgDialog(scope.row, img)"
          >
            <span
              class="btn mr5"
              @click.stop="onReportSuspectPict(scope.row, img)"
            >
              {{
                img.suspectInfo.isReport == isReportEnum.N &&
                img.suspectInfo.reportType == ReportTypeEnum.WAIT_AUDIT
                  ? "AI纠正"
                  : ""
              }}
            </span>
            <CustomDropdown
              v-if="
                img.suspectInfo.isReport == isReportEnum.N &&
                img.suspectInfo.reportType == ReportTypeEnum.WAIT_AUDIT
              "
              :item="img"
              :options="feedbackOptions"
              @confirm="onDropdownConfirm(scope.row, img, $event)"
            />
            <span
              class="btn"
              @click.stop="onReportSuspectPict(scope.row, img)"
              v-if="
                img.suspectInfo.isReport == isReportEnum.Y &&
                img.suspectInfo.reportType == ReportTypeEnum.MANUAL
              "
            >
              取消反馈
            </span>
          </el-button>
        </div>
        <!-- 待审核 部分合格 不合格  tab 情况下 系统没有识别出不合规场景 人工可手动审核 -->
        <div
          class="font-S12 t-center mt10 img-text"
          v-if="[1, 3, 4].includes(activeTab)"
        >
          <el-button size="mini" type="text" v-if="img.notSuspectInfo">
            <CustomDropdown
              :options="feedbackOptions"
              @confirm="onDropdownConfirm(scope.row, img, $event)"
            />
          </el-button>
          <el-button
            size="mini"
            type="text"
            v-if="
              img.suspectInfo.isReport == isReportEnum.Y &&
              img.suspectInfo.reportType == ReportTypeEnum.AI
            "
            @click.stop="onReportSuspectPict(scope.row, img)"
          >
            <span class="btn"> 取消纠错 </span>
          </el-button>
        </div>
      </div>
    </span>
    <!-- 按钮右边 -->
    <div
      v-if="expandImage"
      class="flex items-center btn-move"
      @click="
        moveRight(
          scope.$index,
          getImgUrl(scope.row.bizData.surveySubjects[index]['column_' + index])
            ?.length
        )
      "
    >
      <i
        v-if="
          getImgUrl(scope.row.bizData.surveySubjects[index]['column_' + index])
            ?.length > 0 &&
          (rowPageStates[scope.$index]?.currentPage || 1) <
            Math.ceil(
              getImgUrl(
                scope.row.bizData.surveySubjects[index]['column_' + index]
              )?.length / rowPageStatespageSize
            )
        "
        class="el-icon-arrow-right btn-left"
      ></i>
    </div>
  </div>
</template>

<script>
import CustomDropdown from "../components/CustomDropdown.vue";
import { ReportTypeEnum, isReportEnum, isReportMap } from "../enum";

export default {
  components: {
    CustomDropdown,
  },
  props: [
    "expandImage",
    "index",
    "moveLeft",
    "moveRight",
    "getImgUrl",
    "previewImg",
    "getComma",
    "scope",
    "rowPageStatespageSize",
    "rowPageStates",
    "showBtn",
    "activeTab",
    "onAuditImgDialog",
    "onReportSuspectPict",
    "feedbackOptions",
  ],
  data() {
    return {
      ReportTypeEnum,
      isReportMap,
      isReportEnum,
    };
  },
  methods: {
    // 下拉框确认事件
    onDropdownConfirm(item, img, selectedValues) {
      this.onReportSuspectPict(item, img, selectedValues);
    },
    onShowBtn(img) {
      // showBtn 是否展示 审核按钮
      //     展示的情况下  只有待审核 部分合格 不合格  tab 才展示
      // 并且 不是 ai 纠错
      return (
        this.showBtn &&
        [1, 3, 4].includes(this.activeTab) &&
        img.suspectInfo?.afterSuspectType?.length &&
        (img.suspectInfo.isReport != this.isReportEnum.Y ||
          img.suspectInfo.reportType != this.ReportTypeEnum.AI)
      );
    },
    getBgStyle(img) {
      if (
        (img.suspectInfo?.reportType != this.ReportTypeEnum.AI &&
          img.suspectInfo?.suspectType?.length) ||
        img.suspectInfo?.reportType == this.ReportTypeEnum.MANUAL
      ) {
        return isReportMap[isReportEnum.N].style;
      } else {
        return isReportMap[isReportEnum.Y].style;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
}
.items-center {
  align-items: center;
}
.img-text {
  align-items: center;
  justify-content: center;
  white-space: normal;
  overflow-wrap: break-word;
  padding: 4px 6px;
  .text-bage {
    border-radius: 50%;
    width: 16px;
    height: 16px;
    text-align: center;
    line-height: 16px;
  }
  .border-b-1 {
    border-bottom: 1px solid #000;
  }
  .btn {
    color: #212121;
    border-bottom: 1px solid #333;
  }
}
.btn-move {
  width: 23px;
  margin-right: 8px;
}
.btn-left {
  width: 23px;
  height: 40px;
  opacity: 0.25;
  background: #000000;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-left:hover {
  opacity: 0.45;
}
</style>
